import { useContext } from 'react'
import Modal, { ModalHeader, ModalBody } from '../../../../common/Modal'
import {
  SalesCodeComplexityContext,
  SET_SHOW_HIDE_FORM_POPUP,
} from '../context/context'
import SalesCodeComplexityForm from './SalesCodeComplexityForm'

const SalesCodeComplexityFormModal = (props) => {
  const [salesCodeState, salesCodeDispatch] = useContext(
    SalesCodeComplexityContext
  )

  return (
    <Modal
      onClose={() => {
        salesCodeDispatch({
          type: SET_SHOW_HIDE_FORM_POPUP,
          data: false,
        })
        props.getSalesCodeComplexityData(null, true)
      }}
      show={salesCodeState?.showUploadPopup}
      size={'w-3/4'}
    >
      <ModalHeader className={'text-white'}>Sales Code Complexity</ModalHeader>
      <ModalBody>
        <SalesCodeComplexityForm
          getSalesCodeComplexityData={props.getSalesCodeComplexityData}
        />
      </ModalBody>
    </Modal>
  )
}

export default SalesCodeComplexityFormModal
